import { MDN } from './mdn';

export class AssignedNumber {
    username: string;
    callback: string;
    number: MDN;
}
